<template>
  <svg class="icon-draggable" xmlns="http://www.w3.org/2000/svg" width="15.514" height="7.5" viewBox="0 0 15.514 7.5"><rect width="15.514" height="1.5" rx="0.75" fill="#939393"/><rect width="15.514" height="1.5" rx="0.75" transform="translate(0 6)" fill="#939393"/></svg>
</template>
<script>
  export default {
    name: 'icon-draggable'
  }
</script>
